export interface CampaignEntry {
    id?: number;
    product: string;
    brand: string;
    distributor: string;
    minimumTires: number;
    points: number;
    workshopType: string;
    tireSizes: number[];
}

export interface CampaignFormData {
    product: string;
    brand: string;
    distributor: string;
    minimumTires: number;
    points: number;
    workshopType: string;
    tireSizes: number[];
}

export enum WorkshopType {
    POINT_S = 'Point S',
    POINT_S_EXPRESS = 'Point S Express',
}